

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, PropSync, Watch} from "vue-property-decorator";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import {IOnOffHandlers} from "bonomo";
import {IErrors} from "@/model/IErrors";
import HelpCard from "@/components/shared/HelpCard.vue";
import {namespace} from "vuex-class";
import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue";
import {IRestrictCellsActionParam} from "@/model/Locker/lockerInterfaces";

const serviceProviderModule = namespace("serviceProviderModule");
const lockerModule = namespace("lockerModule");

@Component({
  name: 'SPDuplicateDialog',
  components: {
    HelpCard,
    ServiceProviderChip
  }
})
export default class SPDuplicateDialog extends Vue {

  @Prop()
  protected show!: boolean;

  @Prop()
  private spId!: number;

  private persistent: boolean = true;
  private disabled: boolean = false;
  private loading: boolean = true;
  private success: boolean = false;


  @serviceProviderModule.Action('duplicateServiceProvider')
  private duplicateServiceProvider!: (spId: number) => null

  @serviceProviderModule.Getter('serviceProviderById')
  private serviceProviderById!: (spId: number) => IShortServiceProvider

  @serviceProviderModule.Action("forceFetchServiceProviders")
  private fetchServiceProviders!: () => void;
  private copiedSpId: number = 0;

  private get serviceProvider(): IShortServiceProvider {
    return this.serviceProviderById(this.spId);
  }

  @Watch('show')
  private fetchServiceProvidersIfNecessary() {
    if (this.show && !this.serviceProvider) {
      this.startFetchServiceProviders();
    }
  }

  private ons: IOnOffHandlers = {};
  private errors: string[] = [];

  private created() {
    this.resetState();
    this.ons = this.$ons({
      'backend.call.OK.serviceProviderDuplicated': this.onServiceProviderFinishDuplication,
      'backend.call.KO.serviceProviderDuplicated': this.manageErrors,
      'backend.call.OK.serviceProvidersLoaded': this.onServiceProviderListFinishLoading,
      'backend.call.KO.serviceProvidersLoaded': this.manageErrors,
    });
    this.fetchServiceProvidersIfNecessary();
  }

  public beforeDestroy() {
    this.$offs(this.ons);
  }

  private onClose() {
    this.resetState();
    this.$emit('close');
  }

  private onStartDuplication() {
    this.resetState();
    this.disabled = true;
    this.startDuplicateServiceProvider();
  }

  private onServiceProviderFinishDuplication(sp: any) {
    this.resetState(); // does the loading = false 
    this.success = true;
    this.copiedSpId = sp.id;
  }

  private  onServiceProviderListFinishLoading() {
    this.loading = false;
  }

  private onGoToCopiedServiceProvider() {
    this.$emit('close');
    this.$router.push({ name: 'serviceProvider', params: {spId: `${this.copiedSpId}`}})
    this.resetState();  // this goes last because we need the copiedSpId
  }

  private manageErrors(errors: IErrors) {
    this.resetState();
    this.errors = errors._ || ['?????'];
  }

  private resetState() {
    this.copiedSpId = 0;
    this.disabled = false;
    this.loading = false;
    this.success = false;
    this.errors = [];
  }

  private startFetchServiceProviders() {
    this.loading = true;
    this.fetchServiceProviders();
  }

  private startDuplicateServiceProvider() {
    this.loading = true;
    this.duplicateServiceProvider(this.spId);
  }

}

